class RecentBreadcrumbs extends HTMLElement {
  constructor() {
    super();
    this.STORAGE_KEY = 'visitedRoutes';
    this.maxRoutes = parseInt(this.getAttribute('max-routes')) || 5;
    this.defaultColTitle = this.getAttribute('data-default-title') || 'All';
    this.defaultColUrl =this.getAttribute('data-default-url') || '';
    this.arrow = this.querySelector('div svg');
    this.container = this;
  }

  connectedCallback() {
    this.trackRoute();
    this.renderBreadcrumbs();
  }

// Helper: Create breadcrumb link + optional arrow using fragment
createBreadcrumbItem(href, text, includeArrow = true) {
  const fragment = document.createDocumentFragment();
  
  const li = document.createElement('li');
  const link = document.createElement('a');
  link.href = href;
  link.innerText = text;
  link.setAttribute('aria-label', `Navigate to: ${text}`);
  li.appendChild(link);
  fragment.appendChild(li);

  if (includeArrow && this.arrow) {
    const sepLi = document.createElement('li');
    sepLi.appendChild(this.arrow.cloneNode(true));
    fragment.appendChild(sepLi);
  }

  this.appendChild(fragment);
  
}


// Helper: Get and clean history
getCleanedHistory() {
  let data = JSON.parse(localStorage.getItem(this.STORAGE_KEY)) || [];

  // Remove duplicate /products/ entries
  data = data.filter(entry => !entry.path.includes('/products/'));

  return data;
}

// Helper: Deduplicate & trim
deduplicateAndTrim(data) {
  // Sort by most recent
  data.sort((a, b) => new Date(b.accessedAt) - new Date(a.accessedAt));

  const seen = new Set();
  const unique = [];
  for (const entry of data) {
    if (!seen.has(entry.path)) {
      unique.push(entry);
      seen.add(entry.path);
    }
  }

  const latestProductEntriesMap = new Map();
  for (const entry of unique) {
    if (entry.path.includes('/products/')) {
      const existing = latestProductEntriesMap.get(entry.path);
      if (!existing || new Date(entry.accessedAt) > new Date(existing.accessedAt)) {
        latestProductEntriesMap.set(entry.path, entry);
      }
    }
  }

  const latestProductEntries = Array.from(latestProductEntriesMap.values());
  const nonProductEntries = unique.filter(e => !e.path.includes('/products/'));

  return [...latestProductEntries, ...nonProductEntries].slice(0, this.maxRoutes);
}

trackRoute() {
  const currentPath = window.location.pathname;
  const currentHref = window.location.href;
  const now = new Date().toISOString();

  if (currentPath === '/') {
    localStorage.removeItem(this.STORAGE_KEY);
    this.innerHTML = '';
    return;
  }

  let data = this.getCleanedHistory();

  if (currentPath.includes('/products/') && data.length === 1) {
    this.createBreadcrumbItem(this.defaultColUrl, this.defaultColTitle, true);
  }

  // Add new route
  data.push({ path: currentPath, href: currentHref, accessedAt: now });

  // Deduplicate and trim
  data = this.deduplicateAndTrim(data);

  // Save
  localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
}

renderBreadcrumbs() {
  const currentPath = window.location.pathname;
  const data = JSON.parse(localStorage.getItem(this.STORAGE_KEY)) || [];
  const breadcrumbRoutes = [...data].reverse(); // Oldest to newest

  this.innerHTML = '';

  if (currentPath.includes('/products/') && data.length === 1) {
    this.createBreadcrumbItem(this.defaultColUrl, this.defaultColTitle, true);
  }

  breadcrumbRoutes.forEach((route, index) => {
    if (route.path === '/') return;

    const parts = route.path.split('/').filter(Boolean);
    const name = parts.length ? decodeURIComponent(parts[parts.length - 1]) : '';
    const text = name.charAt(0).toUpperCase() + name.slice(1);
    const isLast = index === breadcrumbRoutes.length - 1;

    this.createBreadcrumbItem(route.href, text, !isLast);
  });
}


}

customElements.define('recent-breadcrumbs', RecentBreadcrumbs);